
import { useState } from 'react';

interface BookingFormProps {
  selectedTour?: string;
}

export default function BookingForm({ selectedTour }: BookingFormProps) {
  const [formData, setFormData] = useState({
    tourPackage: selectedTour || 'Evening Desert Safari',
    name: '',
    email: '',
    countryCode: '+971',
    phone: '',
    date: '',
    adults: 2,
    children: 0,
    buggies: 1,
    totalPrice: 150,
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  const [bookingNumber, setBookingNumber] = useState('');

  const countryCodes = [
    { code: '+93', country: 'Afghanistan' },
    { code: '+355', country: 'Albania' },
    { code: '+213', country: 'Algeria' },
    { code: '+1684', country: 'American Samoa' },
    { code: '+376', country: 'Andorra' },
    { code: '+244', country: 'Angola' },
    { code: '+1264', country: 'Anguilla' },
    { code: '+672', country: 'Antarctica' },
    { code: '+1268', country: 'Antigua and Barbuda' },
    { code: '+54', country: 'Argentina' },
    { code: '+374', country: 'Armenia' },
    { code: '+297', country: 'Aruba' },
    { code: '+61', country: 'Australia' },
    { code: '+43', country: 'Austria' },
    { code: '+994', country: 'Azerbaijan' },
    { code: '+1242', country: 'Bahamas' },
    { code: '+973', country: 'Bahrain' },
    { code: '+880', country: 'Bangladesh' },
    { code: '+1246', country: 'Barbados' },
    { code: '+375', country: 'Belarus' },
    { code: '+32', country: 'Belgium' },
    { code: '+501', country: 'Belize' },
    { code: '+229', country: 'Benin' },
    { code: '+1441', country: 'Bermuda' },
    { code: '+975', country: 'Bhutan' },
    { code: '+591', country: 'Bolivia' },
    { code: '+387', country: 'Bosnia and Herzegovina' },
    { code: '+267', country: 'Botswana' },
    { code: '+55', country: 'Brazil' },
    { code: '+246', country: 'British Indian Ocean Territory' },
    { code: '+673', country: 'Brunei' },
    { code: '+359', country: 'Bulgaria' },
    { code: '+226', country: 'Burkina Faso' },
    { code: '+257', country: 'Burundi' },
    { code: '+855', country: 'Cambodia' },
    { code: '+237', country: 'Cameroon' },
    { code: '+1', country: 'Canada' },
    { code: '+238', country: 'Cape Verde' },
    { code: '+1345', country: 'Cayman Islands' },
    { code: '+236', country: 'Central African Republic' },
    { code: '+235', country: 'Chad' },
    { code: '+56', country: 'Chile' },
    { code: '+86', country: 'China' },
    { code: '+61', country: 'Christmas Island' },
    { code: '+61', country: 'Cocos Islands' },
    { code: '+57', country: 'Colombia' },
    { code: '+269', country: 'Comoros' },
    { code: '+242', country: 'Congo' },
    { code: '+243', country: 'Congo (DRC)' },
    { code: '+682', country: 'Cook Islands' },
    { code: '+506', country: 'Costa Rica' },
    { code: '+225', country: "Côte d'Ivoire" },
    { code: '+385', country: 'Croatia' },
    { code: '+53', country: 'Cuba' },
    { code: '+357', country: 'Cyprus' },
    { code: '+420', country: 'Czech Republic' },
    { code: '+45', country: 'Denmark' },
    { code: '+253', country: 'Djibouti' },
    { code: '+1767', country: 'Dominica' },
    { code: '+1809', country: 'Dominican Republic' },
    { code: '+593', country: 'Ecuador' },
    { code: '+20', country: 'Egypt' },
    { code: '+503', country: 'El Salvador' },
    { code: '+240', country: 'Equatorial Guinea' },
    { code: '+291', country: 'Eritrea' },
    { code: '+372', country: 'Estonia' },
    { code: '+251', country: 'Ethiopia' },
    { code: '+500', country: 'Falkland Islands' },
    { code: '+298', country: 'Faroe Islands' },
    { code: '+679', country: 'Fiji' },
    { code: '+358', country: 'Finland' },
    { code: '+33', country: 'France' },
    { code: '+594', country: 'French Guiana' },
    { code: '+689', country: 'French Polynesia' },
    { code: '+241', country: 'Gabon' },
    { code: '+220', country: 'Gambia' },
    { code: '+995', country: 'Georgia' },
    { code: '+49', country: 'Germany' },
    { code: '+233', country: 'Ghana' },
    { code: '+350', country: 'Gibraltar' },
    { code: '+30', country: 'Greece' },
    { code: '+299', country: 'Greenland' },
    { code: '+1473', country: 'Grenada' },
    { code: '+590', country: 'Guadeloupe' },
    { code: '+1671', country: 'Guam' },
    { code: '+502', country: 'Guatemala' },
    { code: '+44', country: 'Guernsey' },
    { code: '+224', country: 'Guinea' },
    { code: '+245', country: 'Guinea-Bissau' },
    { code: '+592', country: 'Guyana' },
    { code: '+509', country: 'Haiti' },
    { code: '+504', country: 'Honduras' },
    { code: '+852', country: 'Hong Kong' },
    { code: '+36', country: 'Hungary' },
    { code: '+354', country: 'Iceland' },
    { code: '+91', country: 'India' },
    { code: '+62', country: 'Indonesia' },
    { code: '+98', country: 'Iran' },
    { code: '+964', country: 'Iraq' },
    { code: '+353', country: 'Ireland' },
    { code: '+44', country: 'Isle of Man' },
    { code: '+972', country: 'Israel' },
    { code: '+39', country: 'Italy' },
    { code: '+1876', country: 'Jamaica' },
    { code: '+81', country: 'Japan' },
    { code: '+44', country: 'Jersey' },
    { code: '+962', country: 'Jordan' },
    { code: '+7', country: 'Kazakhstan' },
    { code: '+254', country: 'Kenya' },
    { code: '+686', country: 'Kiribati' },
    { code: '+850', country: 'North Korea' },
    { code: '+82', country: 'South Korea' },
    { code: '+965', country: 'Kuwait' },
    { code: '+996', country: 'Kyrgyzstan' },
    { code: '+856', country: 'Laos' },
    { code: '+371', country: 'Latvia' },
    { code: '+961', country: 'Lebanon' },
    { code: '+266', country: 'Lesotho' },
    { code: '+231', country: 'Liberia' },
    { code: '+218', country: 'Libya' },
    { code: '+423', country: 'Liechtenstein' },
    { code: '+370', country: 'Lithuania' },
    { code: '+352', country: 'Luxembourg' },
    { code: '+853', country: 'Macao' },
    { code: '+389', country: 'Macedonia' },
    { code: '+261', country: 'Madagascar' },
    { code: '+265', country: 'Malawi' },
    { code: '+60', country: 'Malaysia' },
    { code: '+960', country: 'Maldives' },
    { code: '+223', country: 'Mali' },
    { code: '+356', country: 'Malta' },
    { code: '+692', country: 'Marshall Islands' },
    { code: '+596', country: 'Martinique' },
    { code: '+222', country: 'Mauritania' },
    { code: '+230', country: 'Mauritius' },
    { code: '+262', country: 'Mayotte' },
    { code: '+52', country: 'Mexico' },
    { code: '+691', country: 'Micronesia' },
    { code: '+373', country: 'Moldova' },
    { code: '+377', country: 'Monaco' },
    { code: '+976', country: 'Mongolia' },
    { code: '+382', country: 'Montenegro' },
    { code: '+1664', country: 'Montserrat' },
    { code: '+212', country: 'Morocco' },
    { code: '+258', country: 'Mozambique' },
    { code: '+95', country: 'Myanmar' },
    { code: '+264', country: 'Namibia' },
    { code: '+674', country: 'Nauru' },
    { code: '+977', country: 'Nepal' },
    { code: '+31', country: 'Netherlands' },
    { code: '+599', country: 'Netherlands Antilles' },
    { code: '+687', country: 'New Caledonia' },
    { code: '+64', country: 'New Zealand' },
    { code: '+505', country: 'Nicaragua' },
    { code: '+227', country: 'Niger' },
    { code: '+234', country: 'Nigeria' },
    { code: '+683', country: 'Niue' },
    { code: '+672', country: 'Norfolk Island' },
    { code: '+1670', country: 'Northern Mariana Islands' },
    { code: '+47', country: 'Norway' },
    { code: '+968', country: 'Oman' },
    { code: '+92', country: 'Pakistan' },
    { code: '+680', country: 'Palau' },
    { code: '+970', country: 'Palestine' },
    { code: '+507', country: 'Panama' },
    { code: '+675', country: 'Papua New Guinea' },
    { code: '+595', country: 'Paraguay' },
    { code: '+51', country: 'Peru' },
    { code: '+63', country: 'Philippines' },
    { code: '+48', country: 'Poland' },
    { code: '+351', country: 'Portugal' },
    { code: '+1787', country: 'Puerto Rico' },
    { code: '+974', country: 'Qatar' },
    { code: '+262', country: 'Réunion' },
    { code: '+40', country: 'Romania' },
    { code: '+7', country: 'Russia' },
    { code: '+250', country: 'Rwanda' },
    { code: '+290', country: 'Saint Helena' },
    { code: '+1869', country: 'Saint Kitts and Nevis' },
    { code: '+1758', country: 'Saint Lucia' },
    { code: '+508', country: 'Saint Pierre and Miquelon' },
    { code: '+1784', country: 'Saint Vincent and the Grenadines' },
    { code: '+685', country: 'Samoa' },
    { code: '+378', country: 'San Marino' },
    { code: '+239', country: 'São Tomé and Príncipe' },
    { code: '+966', country: 'Saudi Arabia' },
    { code: '+221', country: 'Senegal' },
    { code: '+381', country: 'Serbia' },
    { code: '+248', country: 'Seychelles' },
    { code: '+232', country: 'Sierra Leone' },
    { code: '+65', country: 'Singapore' },
    { code: '+421', country: 'Slovakia' },
    { code: '+386', country: 'Slovenia' },
    { code: '+689', country: 'Solomon Islands' },
    { code: '+252', country: 'Somalia' },
    { code: '+27', country: 'South Africa' },
    { code: '+211', country: 'South Sudan' },
    { code: '+34', country: 'Spain' },
    { code: '+94', country: 'Sri Lanka' },
    { code: '+249', country: 'Sudan' },
    { code: '+597', country: 'Suriname' },
    { code: '+268', country: 'Swaziland' },
    { code: '+46', country: 'Sweden' },
    { code: '+41', country: 'Switzerland' },
    { code: '+963', country: 'Syria' },
    { code: '+886', country: 'Taiwan' },
    { code: '+992', country: 'Tajikistan' },
    { code: '+255', country: 'Tanzania' },
    { code: '+66', country: 'Thailand' },
    { code: '+670', country: 'Timor-Leste' },
    { code: '+228', country: 'Togo' },
    { code: '+690', country: 'Tokelau' },
    { code: '+676', country: 'Tonga' },
    { code: '+1868', country: 'Trinidad and Tobago' },
    { code: '+216', country: 'Tunisia' },
    { code: '+90', country: 'Turkey' },
    { code: '+993', country: 'Turkmenistan' },
    { code: '+1649', country: 'Turks and Caicos Islands' },
    { code: '+688', country: 'Tuvalu' },
    { code: '+256', country: 'Uganda' },
    { code: '+380', country: 'Ukraine' },
    { code: '+971', country: 'United Arab Emirates' },
    { code: '+44', country: 'United Kingdom' },
    { code: '+1', country: 'United States' },
    { code: '+598', country: 'Uruguay' },
    { code: '+998', country: 'Uzbekistan' },
    { code: '+678', country: 'Vanuatu' },
    { code: '+379', country: 'Vatican City' },
    { code: '+58', country: 'Venezuela' },
    { code: '+84', country: 'Vietnam' },
    { code: '+1284', country: 'British Virgin Islands' },
    { code: '+1340', country: 'US Virgin Islands' },
    { code: '+681', country: 'Wallis and Futuna' },
    { code: '+212', country: 'Western Sahara' },
    { code: '+967', country: 'Yemen' },
    { code: '+260', country: 'Zambia' },
    { code: '+263', country: 'Zimbabwe' }
  ];

  const tours = [
    { name: 'Evening Desert Safari', price: 149 },
    { name: 'VIP Desert Safari', price: 199 },
    { name: 'Morning Desert Safari', price: 129 },
    { name: 'Sunrise Desert Safari', price: 139 },
    { name: 'Quad Bike Safari', price: 179 },
    { name: 'Dirt Bike Adventure', price: 249 },
    { name: 'Desert Buggy Dubai', price: 299 },
    { name: 'Premium Desert Safari', price: 229 },
    { name: 'Half Day Desert Safari', price: 119 },
    { name: 'Overnight Desert Safari', price: 349 },
    { name: 'Private Desert Safari', price: 599 }
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const calculateTotal = () => {
    const selectedTour = tours.find(tour => tour.name === formData.tour);
    if (!selectedTour) return 0;

    if (formData.tour === 'Desert Buggy Dubai') {
      return selectedTour.price * formData.buggies;
    } else {
      return selectedTour.price * (formData.adults + formData.children);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      // Generate booking number
      const bookingNumber = `DS${Date.now().toString().slice(-8)}${Math.floor(Math.random() * 100).toString().padStart(2, '0')}`;
      
      const submitData = new URLSearchParams();
      submitData.append('booking_number', bookingNumber);
      submitData.append('tour_package', formData.tourPackage);
      submitData.append('name', formData.name);
      submitData.append('email', formData.email);
      submitData.append('phone', `${formData.countryCode} ${formData.phone}`);
      submitData.append('date', formData.date);
      
      if (formData.tourPackage === 'Desert Buggy Dubai') {
        submitData.append('buggies', formData.buggies.toString());
      } else {
        submitData.append('adults', formData.adults.toString());
        submitData.append('children', formData.children.toString());
      }
      
      submitData.append('total_price', `${formData.totalPrice} AED`);
      submitData.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d46f49534biqimnfo37g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: submitData
      });

      if (response.ok) {
        setSubmitStatus('success');
        setBookingNumber(bookingNumber);
        setFormData({
          tourPackage: 'Evening Desert Safari',
          name: '',
          email: '',
          countryCode: '+971',
          phone: '',
          date: '',
          adults: 2,
          children: 0,
          buggies: 1,
          totalPrice: 150,
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
        <div className="bg-gradient-to-r from-yellow-600 to-yellow-500 p-8 text-white text-center">
          <h1 className="text-4xl font-bold mb-2">Book Your Desert Adventure</h1>
          <p className="text-xl opacity-90">Experience the magic of Dubai's desert with our premium safari tours</p>
        </div>

        {/* Success Message */}
        {submitStatus === 'success' && (
          <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
            <div className="flex items-center">
              <i className="ri-check-circle-line text-green-600 text-xl mr-3"></i>
              <div>
                <h4 className="text-green-800 font-semibold">Booking Confirmed!</h4>
                <p className="text-green-700 text-sm mt-1">
                  Your booking number is: <strong>{bookingNumber}</strong>
                </p>
                <p className="text-green-700 text-sm">
                  Confirmation details have been sent to your email. We'll contact you within 24 hours.
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Error Message */}
        {submitStatus === 'error' && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
            <div className="flex items-center">
              <i className="ri-error-warning-line text-red-600 text-xl mr-3"></i>
              <div>
                <h4 className="text-red-800 font-semibold">Booking Failed</h4>
                <p className="text-red-700 text-sm mt-1">
                  Please try again or contact us at dubaidesertfun@gmail.com
                </p>
              </div>
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form>
          {/* Tour Selection */}
          <div>
            <label className="block text-lg font-semibold text-gray-700 mb-3">
              <i className="ri-map-pin-line text-yellow-600 mr-2"></i>
              Select Your Tour
            </label>
            <select
              name="tour"
              value={formData.tour}
              onChange={handleInputChange}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-lg pr-8"
            >
              <option value="">Choose a tour package...</option>
              {tours.map((tour, index) => (
                <option key={index} value={tour.name}>
                  {tour.name} - {tour.price} AED
                </option>
              ))}
            </select>
          </div>

          {/* Personal Information */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-lg font-semibold text-gray-700 mb-3">
                <i className="ri-user-line text-yellow-600 mr-2"></i>
                Full Name
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-lg"
                placeholder="Enter your full name"
              />
            </div>

            <div>
              <label className="block text-lg font-semibold text-gray-700 mb-3">
                <i className="ri-mail-line text-yellow-600 mr-2"></i>
                Email Address
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-lg"
                placeholder="Enter your email"
              />
            </div>
          </div>

          {/* Phone Number with Country Code */}
          <div>
            <label className="block text-lg font-semibold text-gray-700 mb-3">
              <i className="ri-phone-line text-yellow-600 mr-2"></i>
              Phone Number
            </label>
            <div className="flex gap-3">
              <select
                name="countryCode"
                value={formData.countryCode}
                onChange={handleInputChange}
                className="px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-lg pr-8"
              >
                {countryCodes.map((country, index) => (
                  <option key={index} value={country.code}>
                    {country.code} {country.country}
                  </option>
                ))}
              </select>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                required
                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-lg"
                placeholder="Enter phone number"
              />
            </div>
          </div>

          {/* Date Selection */}
          <div>
            <label className="block text-lg font-semibold text-gray-700 mb-3">
              <i className="ri-calendar-line text-yellow-600 mr-2"></i>
              Preferred Date
            </label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleInputChange}
              required
              min={new Date().toISOString().split('T')[0]}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-lg"
            />
          </div>

          {/* Participants or Buggies */}
          {formData.tour === 'Desert Buggy Dubai' ? (
            <div>
              <label className="block text-lg font-semibold text-gray-700 mb-3">
                <i className="ri-car-line text-yellow-600 mr-2"></i>
                Number of Buggies
              </label>
              <select
                name="buggies"
                value={formData.buggies}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-lg pr-8"
              >
                {[1, 2, 3, 4, 5, 6, 7, 8].map(num => (
                  <option key={num} value={num}>{num} Buggy{num > 1 ? 's' : ''}</option>
                ))}
              </select>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-lg font-semibold text-gray-700 mb-3">
                  <i className="ri-user-line text-yellow-600 mr-2"></i>
                  Adults
                </label>
                <select
                  name="adults"
                  value={formData.adults}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-lg pr-8"
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => (
                    <option key={num} value={num}>{num} Adult{num > 1 ? 's' : ''}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-lg font-semibold text-gray-700 mb-3">
                  <i className="ri-user-smile-line text-yellow-600 mr-2"></i>
                  Children
                </label>
                <select
                  name="children"
                  value={formData.children}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-lg pr-8"
                >
                  {[0, 1, 2, 3, 4, 5, 6, 7, 8].map(num => (
                    <option key={num} value={num}>{num} {num === 1 ? 'Child' : 'Children'}</option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {/* Special Requests */}
          <div>
            <label className="block text-lg font-semibold text-gray-700 mb-3">
              <i className="ri-message-3-line text-yellow-600 mr-2"></i>
              Special Requests or Messages
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              maxLength={500}
              rows={4}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent text-lg resize-none"
              placeholder="Any special requests, dietary requirements, or additional information..."
            ></textarea>
            <p className="text-sm text-gray-500 mt-1">{formData.message.length}/500 characters</p>
          </div>

          {/* Price Summary */}
          {formData.tour && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-3">Booking Summary</h3>
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">Tour:</span>
                  <span className="font-semibold">{formData.tour}</span>
                </div>
                {formData.tour === 'Desert Buggy Dubai' ? (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Buggies:</span>
                    <span className="font-semibold">{formData.buggies}</span>
                  </div>
                ) : (
                  <>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Adults:</span>
                      <span className="font-semibold">{formData.adults}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Children:</span>
                      <span className="font-semibold">{formData.children}</span>
                    </div>
                  </>
                )}
                <div className="border-t border-yellow-300 pt-2 mt-3">
                  <div className="flex justify-between text-xl font-bold text-yellow-700">
                    <span>Total:</span>
                    <span>{calculateTotal()} AED</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isSubmitting || !formData.tour}
            className="w-full bg-gradient-to-r from-yellow-600 to-yellow-500 text-white font-bold py-4 px-8 rounded-lg text-xl hover:from-yellow-700 hover:to-yellow-600 transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none whitespace-nowrap cursor-pointer"
          >
            {isSubmitting ? (
              <>
                <i className="ri-loader-4-line animate-spin mr-2"></i>
                Processing Booking...
              </>
            ) : (
              <>
                <i className="ri-send-plane-line mr-2"></i>
                Book Now - {calculateTotal()} AED
              </>
            )}
          </button>

          <div className="text-center text-gray-600">
            <p className="text-sm">
              <i className="ri-shield-check-line text-green-600 mr-1"></i>
              Secure booking • No hidden fees • Instant confirmation
            </p>
            <p className="text-sm mt-2">
              Questions? Contact us at <a href="mailto:dubaidesertfun@gmail.com" className="text-yellow-600 hover:underline">dubaidesertfun@gmail.com</a> or 
              <a href="https://wa.me/971504253450" className="text-yellow-600 hover:underline ml-1">WhatsApp +971-50-425-3450</a>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}
